import { Box, BoxProps, chakra, Flex, FlexProps } from '@chakra-ui/react'
import { useMonth, UseMonthProps } from '@datepicker-react/hooks'
import React from 'react'

import { DPDay } from './DPDay'

const sxMonthDayGrid = {
  '& > *': {
    // Divide into 7 days per row
    flexBasis: `${(100 / 7).toString()}%`,
    flexGrow: 0,
  },
}
const MonthDayGrid: React.FC<FlexProps> = props => (
  <Flex
    flexWrap="wrap"
    margin="0 auto"
    maxWidth="300px"
    sx={sxMonthDayGrid}
    {...props}
  />
)

const MonthContainer: React.FC<BoxProps> = props => (
  <Box
    background="white.0"
    border="1px solid "
    borderColor="neutral.20"
    borderRadius="3px"
    boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.05)"
    padding="15px"
    {...props}
  />
)

const MonthTitle: React.FC<BoxProps> = props => (
  <Box
    borderBottom="1px solid "
    borderColor="neutral.20"
    margin="0 -15px 20px"
    paddingBottom="15px"
    textAlign="center"
    {...props}
  />
)

const MonthDayGridInherited = chakra(MonthDayGrid)
const sxDayLabelContainer = {
  '& > *': {
    textAlign: 'center',
  },
}
const DayLabelContainer: React.FC<FlexProps> = props => (
  <MonthDayGridInherited
    fontWeight="bold"
    margin="10px auto"
    sx={sxDayLabelContainer}
    {...props}
  />
)

export const DPMonth = ({ firstDayOfWeek, month, year }: UseMonthProps) => {
  const { days, monthLabel, weekdayLabels } = useMonth({
    firstDayOfWeek,
    month,
    year,
  })

  return (
    <MonthContainer>
      <MonthTitle>{monthLabel}</MonthTitle>
      <DayLabelContainer>
        {weekdayLabels.map(dayLabel => (
          <div key={dayLabel}>{dayLabel}</div>
        ))}
      </DayLabelContainer>
      <MonthDayGrid>
        {days.map((day, index) =>
          typeof day === 'object' ? (
            <DPDay
              key={day.date.toString()}
              date={day.date}
              dayLabel={day.dayLabel}
            />
          ) : (
            <div key={index} />
          ),
        )}
      </MonthDayGrid>
    </MonthContainer>
  )
}
